/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export type Authorized = { staker: Address; withdrawer: Address };

export type AuthorizedArgs = Authorized;

export function getAuthorizedEncoder(): Encoder<AuthorizedArgs> {
  return getStructEncoder([
    ['staker', getAddressEncoder()],
    ['withdrawer', getAddressEncoder()],
  ]);
}

export function getAuthorizedDecoder(): Decoder<Authorized> {
  return getStructDecoder([
    ['staker', getAddressDecoder()],
    ['withdrawer', getAddressDecoder()],
  ]);
}

export function getAuthorizedCodec(): Codec<AuthorizedArgs, Authorized> {
  return combineCodec(getAuthorizedEncoder(), getAuthorizedDecoder());
}
